import React, { useState, useEffect, useMemo } from "react";
import {
  collection,
  getDocs,
  doc,
  where,
  updateDoc,
  query,
} from "firebase/firestore";
import { db } from "../Config/Firebase";
import UnblockModel from "../Assets/BlockModel";
import UserModel from "../Assets/UserModel";

const UsersTable = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [unblockModalShow, setUnblockModalShow] = useState(false);

  const [itemToUnblock, setItemToUnblock] = useState(null);


    const [userModalShow, setUserModalShow] = useState(false);
  
    const [itemToView, setItemToView] = useState(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15; // Number of rows per page

useEffect(() => {
  const fetchUsers = async () => {
    try {
      const q = query(collection(db, "users"));

      const snapshot = await getDocs(q);

      const userData = snapshot.docs
        .map((doc) => ({ docid: doc.id, ...doc.data() }))
        .filter((user) => user.isBlocked === true );

      setUsers(userData);
      console.log("Users not blocked:", userData);

     
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  fetchUsers();
}, []);

  // UnBlocking User
  const unblockUser = async (user) => {
    try {
      const userRef = doc(db, "users", user.docid);

      // Always set to false when unblocking
      await updateDoc(userRef, { isBlocked: false });

      
      setUsers((prev) => prev.filter((u) => u.docid !== user.docid));
    } catch (error) {
      console.error("Error unblocking user:", error);
    }

    setUnblockModalShow(false);
    setItemToUnblock(null);
  };



  // Filtering and sorting
  const filteredUsers = useMemo(() => {
    const today = new Date();

    let filtered = users.filter((user) => {
      const nameMatch = user.name?.toLowerCase().includes(search.toLowerCase());
      const emailMatch = user.email?.toLowerCase().includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        const createdDate = new Date(user.createdAt);
        if (!isNaN(createdDate)) {
          const diffTime = today - createdDate;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);
        } else {
          matchesDate = false;
        }
      }

      return (nameMatch || emailMatch) && matchesDate;
    });

    if (sortOption === "name-asc") {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => b.name.localeCompare(a.name));
    } else if (sortOption === "date-asc") {
      filtered.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (sortOption === "date-desc") {
      filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }

    return filtered;
  }, [users, search, daysFilter, sortOption]);

  // Pagination logic
  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };


      const handleUnblockClick = (id) => {
      setItemToUnblock(id);
      setUnblockModalShow(true);
    };



        const cancelUnblock = () => {
      setUnblockModalShow(false);
      setItemToUnblock(null);
    };




    const handleViewClick = (id) => {
      setItemToView(id);
      setUserModalShow(true);
    };



        const cancelView = () => {
      setUserModalShow(false);
      setItemToView(null);
    };



  return (
    <div className="Fee-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Temporary Deleted Users</h2>

      {/* Filters */}
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="px-4 py-2 border rounded"
        />

        <select
          value={daysFilter}
          onChange={(e) => setDaysFilter(e.target.value)}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>

        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className="px-2 py-1 border rounded"
                      style={{
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingRight: "1rem",
          }}
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
        </select>
      </div>

      {/* Table */}
      <table className="w-full text-sm border temp-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Mobile</th>
            <th className="px-4 py-2 text-left">Updated On</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((user, index) => (
              <tr key={user.docid} className="border-t">
                <td className="px-4 py-2">
                  {indexOfFirstUser + index + 1}
                </td>
                <td className="px-4 py-2 flex flex-wrap items-center gap-3">
                  <img
                    src={user.profileImageUrl}
                    alt="avatar"
                    className="w-10 h-10 rounded-full"
                  />
                  <span>{user.name || "N/A"}</span>
                </td>
                <td className="px-4 py-2">{user.mobile || "N/A"}</td>
                <td className="px-4 py-2">{formatDateTime(user.updatedAt)}</td>
                <td className="px-4 py-2 space-x-2 flex flex-wrap gap-2">
                  <button
                      onClick={() => handleViewClick(user.docid)}
                      className="px-2 py-1 text-xs rounded bg-red-500 text-white"
                    >
                      View Data
                    </button>
                  <button
                    onClick={() => handleUnblockClick(user.docid)}
                    className="px-2 py-1 text-xs rounded bg-green-500 text-white"
                  >
                    Unblock
                  </button>
                  
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

      
      {unblockModalShow && (
        <UnblockModel
          user={users.find((p) => p.docid === itemToUnblock) || null}
          onClose={cancelUnblock}
          onBlock={() => unblockUser(users.find((p) => p.docid === itemToUnblock))}
        />
      )}

      {userModalShow && (
        <UserModel
          user={users.find((p) => p.docid === itemToView) || null}
          onClose={cancelView}
        />
      )}

    </div>
  );
};

export default UsersTable;

// Format
const formatDateTime = (value) => {
  if (!value) return "";
  let date;
  if (typeof value === "number") {
    date = new Date(value);
  } else if (value?.seconds) {
    date = new Date(value.seconds * 1000);
  } else if (typeof value === "string") {
    date = new Date(value);
  } else {
    return "";
  }
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
